import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c40d33f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view_restriction_wrapper" }
const _hoisted_2 = { class: "view_restriction_body" }
const _hoisted_3 = { class: "view_restriction_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "view_restriction_title_alert" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/alert.svg" })
], -1))
const _hoisted_5 = { class: "view_restriction" }
const _hoisted_6 = {
  key: 0,
  class: "view_restriction_content_wrapper"
}
const _hoisted_7 = { class: "view_restriction_content" }
const _hoisted_8 = { class: "view_restriction_club_name_wrapper" }
const _hoisted_9 = { class: "view_restriction_club_name" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "view_restriction_content_wrapper"
}
const _hoisted_13 = { class: "view_restriction_content" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "view_restriction_buttons_wrapper" }
const _hoisted_16 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_v_alert = _resolveComponent("v-alert")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showAlert,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showAlert) = $event)),
      title: 'clients.view.view_restriction.alert_title',
      text: 'clients.view.view_restriction.alert_text',
      successButtonText: _ctx.$t('clients.view.view_restriction.yes'),
      cancelButtonText: _ctx.$t('clients.view.view_restriction.cancel'),
      onSuccess: _ctx.deleteRestriction,
      onCancel: _cache[1] || (_cache[1] = $event => (_ctx.showAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess"]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.restrictionList?.length == 1 ? _ctx.$t('clients.view.view_restriction.title_with_one_restriction') : _ctx.$t('clients.view.view_restriction.title_with_many_restrictions')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.restrictionList?.length != 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restrictionList, (restriction) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(`${_ctx.$t('clients.view.view_restriction.in_club')} "${restriction.clubName}":`), 1),
                      (_ctx.hasDeleteRestrictionPermission)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "delete_restriction",
                            src: "/assets/img/close.svg",
                            onClick: $event => (_ctx.showDeleteRestrictionAlert(restriction.id))
                          }, null, 8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      innerHTML: restriction.comments
                    }, null, 8, _hoisted_11)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_ctx.restrictionList?.length == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.restrictionList[0].comments
                  }, null, 8, _hoisted_14)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "secondary_button",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
          }, _toDisplayString(_ctx.$t('clients.view.view_restriction.close')), 1),
          (_ctx.hasDeleteRestrictionPermission && _ctx.restrictionList?.length == 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "delete_button",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.showDeleteRestrictionAlert(_ctx.restrictionList[0].id))),
                disabled: _ctx.isButtonDisabled
              }, _toDisplayString(_ctx.$t('clients.view.view_restriction.remove_restriction')), 9, _hoisted_16))
            : _createCommentVNode("", true)
        ])
      ])), [
        [_directive_click_outside, _ctx.clickOutside]
      ])
    ])
  ], 64))
}